export default __webpack_public_path__ + "static/media/IBMPlexSans-Text-Latin1.1992c01b.woff2";